var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "watermark-container" }, [
    _c("div", { ref: "watermarkContent", staticClass: "watermark-content" }, [
      _c("span", { staticClass: "watermark-text" }, [_vm._v(_vm._s(_vm.text))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }